import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { AppBar, Box, Checkbox, Dialog, FormControlLabel, FormGroup, IconButton, Paper, Toolbar, Typography } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Graph } from '../../Dashboard/dashboardTypes';
import { type CsvStreamLabelOptions, csvStreamLabel } from './csvStreamLabel';

interface CsvDownloadDiologProps {
  sensors: Array<Graph>;
  open: boolean;
  handleClose: () => void;
  chosenSensors: Array<string>;
  setChosenSensors: Dispatch<SetStateAction<string[]>>;
  generateCSV: () => void;
  /** Port / variable / metric label options for motors, mechanisms, and sensors. */
  csvStreamLabelOptions?: CsvStreamLabelOptions;
}

const CsvDownloadDialog = ({
  sensors,
  open,
  handleClose,
  chosenSensors,
  setChosenSensors,
  generateCSV,
  csvStreamLabelOptions,
}: CsvDownloadDiologProps) => {
  const { t } = useTranslation();

  const handleChange = (key: string) => {
    const chosen = [...chosenSensors];
    const index = chosen.indexOf(key);
    if (index === -1) {
      chosen.push(key);
    } else {
      chosen.splice(index, 1);
    }
    setChosenSensors(chosen);
  };

  return (
    <Dialog onClose={() => handleClose()} open={open} maxWidth="sm">
      <AppBar position="static">
        <Toolbar>
          <IconButton onClick={handleClose} color="inherit">
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            <Trans i18nKey="button.download.CSV"> DOWNLOAD CSV DATA</Trans>
          </Typography>
          <Box sx={{ minWidth: 64, display: 'flex', justifyContent: 'center', flexShrink: 0 }}>
            {chosenSensors.length > 0 && (
              <IconButton onClick={generateCSV} color="inherit">
                <FileDownloadIcon />
              </IconButton>
            )}
          </Box>
        </Toolbar>
      </AppBar>
      <Paper elevation={24} square={false} sx={{ p: 4 }}>
        <FormGroup>
          {(sensors ?? [])
            .filter((sensor) => sensor.data.length > 0)
            .map((sensor) => (
              <FormControlLabel
                key={sensor.key}
                control={<Checkbox checked={chosenSensors.includes(sensor.key)} onChange={() => handleChange(sensor.key)} />}
                label={csvStreamLabel(t, sensor.key, csvStreamLabelOptions)}
              />
            ))}
        </FormGroup>
      </Paper>
    </Dialog>
  );
};

export default CsvDownloadDialog;
